import { PendingDocumentMove, RelationshipType } from "../../../api/ClientFileApi";

export const DependantMaxLength = {
  firstName: 255,
  note: 4000,
} as const;

export const RELATIONSHIP_OPTIONS: RelationshipType[] = [
  "Acquaintance",
  "Parent",
  "ExSpouse",
  "ExPartner",
  "Spouse",
  "Child",
  "Partner",
  "Other",
  "Unknown",
  "Relative",
];

export interface DependantFormValue {
  key: string;
  id: string | null;
  firstName: string | null;
  relationship: RelationshipType | null;
  birthDate: Date | null;
  livesInHousehold: boolean | null;
  isJointlyLiable: boolean | null;
  isEntitledToMaintenance: boolean | null;
  hasToPayAlimony: boolean | null;
  monthlyAlimonyAmount: number | null;
  paidFullLastMonth: boolean | null;
  fullyGarnishedLastMonth: boolean | null;
  note: string | null;
}

export interface AssetRelativesFormValues {
  dependants: DependantFormValue[];
  documents: File[];
  /** Deferred deletes of saved documents — portal fallback only; the internal app deletes via the row actions. */
  documentsToDelete: string[];
  /** Deferred drag-moves — internal app only; stays empty without the documentDnd slice. */
  documentMoves: PendingDocumentMove[];
}

export function createEmptyDependant(key: string): DependantFormValue {
  return {
    key,
    id: null,
    firstName: null,
    relationship: null,
    birthDate: null,
    livesInHousehold: true,
    isJointlyLiable: null,
    isEntitledToMaintenance: null,
    hasToPayAlimony: null,
    monthlyAlimonyAmount: 0,
    paidFullLastMonth: null,
    fullyGarnishedLastMonth: null,
    note: null,
  };
}
